import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../api";
import InputField from "../../../components/Form/InputField";
import ToggleSwitch from "../../../components/Form/ToggleSwitch";
import ImageUploader from "../../../components/Form/ImageUploader";
import TextInput from "../../../components/Form/TextInput";
import {toPersianNumbers} from "../../../utils/toPersianNumbers";
import Button from "../../../components/Button";

export default function CarrierProfileAdminEdit ()  {
  const {id}=useParams();
  const [profile, setProfile] = useState(null);
  const [formData, setFormData] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [profileImagePreview, setProfileImagePreview] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  // --- گرفتن پروفایل کاربر فعلی ---
  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        navigate("/user-login/");
        return;
      }

      try {
        const response = await api.get(
        `accounts/admin/carrier/profile/${id}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
        setProfile(response.data);
        setFormData(response.data);

        if (response.data.profile_picture) {
          setProfileImagePreview(response.data.profile_picture);
        }
      } catch (error) {
        console.error("خطا در گرفتن پروفایل:", error);
        if (error.response?.status === 401) {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("role");
          navigate("/user-login/");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [navigate, id]);

  // --- تغییر فیلدها ---
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // --- ارسال فرم ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const submitData = new FormData();
      const textFields = ['full_name','title', 'description','email',
        'national_id', 'birth_date', 'secondary_phone','is_legal_entity',
      'org_name', 'economic_code','national_legal_id', 'registration_id', 'province',
         'city','office_phone', 'org_email', 'representative_name', 'representative_phone'
      ];

      textFields.forEach(key => {
      if (formData[key] !== null && formData[key] !== undefined) {
        const value = typeof formData[key] === "boolean" ? formData[key] : formData[key] || '';
        submitData.append(key, value);
      }
    });
      if (profileImage instanceof File) {
        submitData.append('logo', profileImage);
      } else if (formData.logo === null) {
        submitData.append('logo', '');
      }

      await api.put(`accounts/admin/carrier/profile/${id}/`, submitData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      alert("پروفایل با موفقیت ویرایش شد");
      navigate(`/admin-panel/carrier-user-management/${id}/view`);
    } catch (error) {
      console.error("خطا در ذخیره پروفایل:", error);
      console.error("داده‌های خطا:", error.response?.data);
      alert("خطا در ذخیره اطلاعات. لطفاً دوباره تلاش کنید.");
    }
  };

  if (loading) return (
    <div className="flex justify-center items-center h-64">
      <p className="text-lg text-gray-600">در حال بارگذاری...</p>
    </div>
  );

  // --- نمایش فرم ---
  return (
    <div className="p-6">
        <form onSubmit={handleSubmit} className="space-y-8">
            {/* بخش عکس پروفایل */}
            <div className="border border-gray-200 rounded-lg p-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">عکس پروفایل</h3>
                <div className="flex items-center gap-6">
                    <div className="relative">
                        <ImageUploader
                            imageUrl={profile.logo}
                            onChange={(file) => {
                                setFormData({...formData, logo: file});
                                setProfileImage(file);
                            }}
                        />
                    </div>
                </div>
            </div>

            <TextInput
                label="توضیحات"
                name="description"
                placeholder="درباره خود و فعالیت‌هایتان بنویسید..."
                value={formData.description || ""}
                onChange={(value) => setFormData((prev) => ({...prev, description: value}))}
            />

            {/* اطلاعات اصلی */}
            <div className="border border-gray-200 rounded-lg p-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">اطلاعات اصلی</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <InputField
                        label="نام و نام خانوادگی*"
                        name="full_name"
                        value={formData.full_name}
                        onChange={handleChange}
                        placeholder={profile.full_name || 'نام و نام خانوادگی خود را وارد کنید'}
                    />
                    <InputField
                        label="عنوان"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        placeholder={profile.title || 'عنوان خود را وارد کنید'}
                    />
                    <InputField
                        label="ایمیل"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder={profile.email || 'ایمیل خود را وارد کنید'}
                    />
                    <InputField
                        label="تاریخ تولد"
                        name="birth_date"
                        type="date"
                        value={formData.birth_date}
                        onChange={handleChange}
                        placeholder={profile.birth_date || 'تاریخ تولد خود را وارد کنید'}
                    />
                    <InputField
                        label="کد ملی"
                        name="national_id"
                        value={toPersianNumbers(formData.national_id)}
                        onChange={handleChange}
                        placeholder={toPersianNumbers(profile.national_id) || 'کد ملی خود را وارد کنید'}
                    />
                    <InputField
                        label="شماره موبایل دوم"
                        name="secondary_phone"
                        value={toPersianNumbers(formData.secondary_phone)}
                        onChange={handleChange}
                        placeholder={toPersianNumbers(profile.secondary_phone) || 'شماره موبایل دوم خود را وارد کنید'}
                    />
                </div>
            </div>

            {/* شخصیت حقوقی */}
            <div className="border border-gray-200 rounded-lg p-6">
                <ToggleSwitch
                    label="شخصیت حقیقی"
                    name="is_legal_entity"
                    checked={!!formData.is_legal_entity}
                    onChange={(e) => setFormData({...formData, is_legal_entity: e.target.checked})}
                />

                {formData.is_legal_entity && (
                    <div className="space-y-6 mt-4">

                        {/* اطلاعات سازمان */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <InputField
                                label="نام سازمان *"
                                name="org_name"
                                value={formData.org_name}
                                onChange={handleChange}
                                placeholder={profile.org_name || 'نام سازمان خود را وارد کنید'}
                            />
                            <InputField
                                label="کد اقتصادی"
                                name="economic_code"
                                value={toPersianNumbers(formData.economic_code)}
                                onChange={handleChange}
                                placeholder={toPersianNumbers(profile.economic_code) || 'شماره موبایل دوم خود را وارد کنید'}
                            />
                            <InputField
                                label="شناسه ملی *"
                                name="national_legal_id"
                                value={toPersianNumbers(formData.national_legal_id)}
                                onChange={handleChange}
                                placeholder={toPersianNumbers(profile.national_legal_id) || 'شماره موبایل دوم خود را وارد کنید'}
                            />
                            <InputField
                                label="شماره ثبت *"
                                name="registration_id"
                                value={toPersianNumbers(formData.registration_id)}
                                onChange={handleChange}
                                placeholder={toPersianNumbers(profile.registration_id) || 'شماره موبایل دوم خود را وارد کنید'}
                            />
                            <InputField
                                label="استان"
                                name="province"
                                value={formData.province}
                                onChange={handleChange}
                                placeholder={profile.province || 'استان خود را وارد کنید'}
                            />
                            <InputField
                                label="شهر"
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                                placeholder={profile.city || 'شهر خود را وارد کنید'}
                            />
                            <InputField
                                label="تلفن ثابت"
                                name="office_phone"
                                value={toPersianNumbers(formData.office_phone)}
                                onChange={handleChange}
                                placeholder={toPersianNumbers(profile.office_phone) || 'تلفن ثابت خود را وارد کنید'}
                            />
                            <InputField
                                label="ایمیل سازمانی"
                                name="org_email"
                                value={formData.org_email}
                                onChange={handleChange}
                                placeholder={profile.org_email || 'شهر خود را وارد کنید'}
                            />
                            <InputField
                                label="نام مدیر عامل / نماینده"
                                name="representative_name"
                                value={formData.representative_name}
                                onChange={handleChange}
                                placeholder={profile.representative_name || 'نام نماینده را وارد کنید'}
                            />
                            <InputField
                                label="شماره موبایل مدیر عامل"
                                name="representative_phone"
                                value={toPersianNumbers(formData.representative_phone)}
                                onChange={handleChange}
                                placeholder={toPersianNumbers(profile.representative_phone) || 'تلفن ثابت خود را وارد کنید'}
                            />
                        </div>
                    </div>
                )}
            </div>

            {/* دکمه‌های اقدام */}
            <div className="flex flex-col sm:flex-row gap-4 pt-6 border-t border-gray-200">
                <Button children={'ذخیره تغییرات'} type='submit'/>
                <Button children={'انصراف'} variant='secondary'
                        onClick={() => navigate(`/admin-panel/carrier-user-management/`)}/>
            </div>
        </form>
    </div>
  );
};



